import * as RadixAvatar from '@radix-ui/react-avatar';
import { styled } from '@styles/stitches';

export const Container = styled('div', {
  position: 'relative',
  display: 'flex',
});

export const StyledRoot = styled(RadixAvatar.Root, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  verticalAlign: 'middle',
  overflow: 'hidden',
  userSelect: 'none',
  width: 128,
  height: 128,
  backgroundColor: '$secondaryBackground',

  variants: {
    round: {
      true: {
        borderRadius: 9999,
      },
    },
  },
});

export const StyledImage = styled(RadixAvatar.Image, {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: 'inherit',
});

export const StyledFallback = styled(RadixAvatar.Fallback, {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const Verified = styled('div', {
  margin: '0 $space$5',
  fontSize: 14,
});

export const Path = styled('path', {});
